<template>

    <modal-container>

        <!-- Top navbar -->
        <modal-header
            :title="'Item is not available'"
            :right="'close-dark'"
            :noIcon="true">
        </modal-header>

        <!-- Prompt content -->
        <prompt-div class="text-dark">

            <!-- Layout body -->
            <template v-slot:body>
                <img class="card-img--modal img img-fluid" :src="'/image/' + productImage" @error="$root.imageAlt" alt="">
                <div class="pt-6">
                    <h3 class="font-lg font-weight-bolder mx-4">We are sorry, this product is not available right now</h3>
                    <div class="font-md justify-content-center mt-4">
                        Try checking other amazing products from our <span v-html="productCategory.name"></span> category we have for you with 0% installments.
                    </div>
                </div>
            </template>

            <!-- Bottom button -->
            <template v-slot:bottom-button>
                <button class="btn btn-lg btn-inverted btn-block text-primary" @click="executeClick()">
                    Check other deals
                </button>
            </template>
        </prompt-div>
    </modal-container>

</template>

<script>
    export default {
        props: {
            params: {
                default: null,
            },
        },

        computed: {
            productCategory: function() {
                return this.params.product.parentCategory;
            },
            productImage: function() {
                return this.params.product.imageId? this.params.product.imageId[0] : 0
            },
        },

        methods: {
            executeClick: function() {
                if (this.productCategory != 'undefined') {
                    this.$router.push({ name: 'listing', query: { type:'category', selected: this.productCategory.id, name: this.productCategory.name }})
                } else {
                    this.$root.closeModal();
                }
            }
        }
    }
</script>
